import { Dropdown } from 'components/dropdown/Dropdown';
import { SelectOption } from 'components/forms/Select';
import { useUser } from 'contexts/UserContext';
import { useEffect, useMemo } from 'react';

const pageSizes = [12, 25, 50, 100];
const pageSizeOptions: SelectOption[] = pageSizes.map((size) => ({
    title: `${size} rows`,
    value: size,
}));
const getId = (item: SelectOption) => item.title;

export function TablePageSizeDropdown() {
    const { pageSize, setPageSize } = useUser();

    const selectedSize = useMemo(
        () => pageSizeOptions.find((option) => option.value === pageSize),
        [pageSize]
    );

    useEffect(() => {
        if (!selectedSize) {
            setPageSize(pageSizes[0]);
        }
    }, [selectedSize, setPageSize]);

    return (
        <Dropdown<SelectOption>
            data={pageSizeOptions}
            dataKey={getId}
            value={selectedSize}
            renderItem={({ item }) => item.title}
            renderLabel={(item) => item.value?.title}
            onChange={(option) => setPageSize(Number(option.value))}
            popup={{ width: '15rem' }}
        />
    );
}
